import {Component, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowStep} from "../workflow-step";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {SuccessComponent} from "../../errors/success.component";

@Component({
  templateUrl: "./project-import-structure.template.pug",
  providers: [],
})
export class ProjectImportStructureComponent extends WorkflowStep {
  private isReady: boolean = false;

  public projectId: string = "";
  public disableStep: boolean = false;
  public error: Error;

  @ViewChild(SuccessComponent) success: SuccessComponent;

  public ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    this.isReady = true;
    this.projectId = workflowTargetInfo.projectId;
    this.loading = false;
  }

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
  ) {
    super(true);
  }
}
